import Button from '@tds/core-button';
import PropTypes from 'prop-types';
import { isBefore, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import DatePicker from 'react-datepicker';
import FlexGrid from '@tds/core-flex-grid';
import Select from '@tds/core-select';
import Tags from '@tds/community-tags';
import Heading from '@tds/core-heading';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { InputWrapper, DateWrapper } from './css';
import { FILTERS_INIT_STATE } from './constants';
import { Box, Text } from '../design/css';

const Filters = ({
  onApplyFilters,
  onResetFilters,
  role,
  assignedUsers,
  defaultFilters
}) => {
  const local = useLocaleContext();
  const {
    ORDERS: { filterByReportedDate },
    DEFECT_MANAGEMENT: {
      FILTER = '',
      FILTER_BY_WEBFORM = {},
      FILTER_BY_CATEGORY = {},
      FILTER_BY_STATUS = {},
      FILTER_BY_ASSIGNEE = {},
      FILTER_BY_DEFECT_CATEGORY_OPTIONS,
      APPLY = '',
      RESET = '',
      STATUS_OPTIONS,
      WEBFORM_OPTIONS,
      FROM,
      TO,
      Showing_Result_For,
      filterKeyToShortTitleMap
    } = {}
  } = local === 'en-US' ? EN : FR;

  const [filter, setFilter] = useState({
    ...FILTERS_INIT_STATE,
    ...defaultFilters
  });

  useEffect(() => {
    setFilter({ ...filter, ...defaultFilters });
  }, [defaultFilters]);

  const onRemoveTagFilter = key => {
    const tempFilters = filter;
    delete tempFilters[key];
    setFilter(tempFilters);
    onApplyFilters(tempFilters);
  };

  return (
    <Box between={3}>
      <ExpandCollapse tag="h2">
        <ExpandCollapse.Panel id={FILTER} header={FILTER}>
          <Box between={1}>
            <FlexGrid>
              <FlexGrid.Row Style="margin-bottom:10px">
                <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                  <Select
                    label={FILTER_BY_WEBFORM.title}
                    placeholder={FILTER_BY_WEBFORM.placeholder}
                    options={WEBFORM_OPTIONS.map(o => ({
                      text: o,
                      value: o
                    }))}
                    onChange={e =>
                      setFilter({ ...filter, defectWebform: e.target.value })
                    }
                    value={filter.defectWebform ? filter.defectWebform : ''}
                  />
                </FlexGrid.Col>
                <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                  <Select
                    label={FILTER_BY_CATEGORY.title}
                    placeholder={FILTER_BY_CATEGORY.placeholder}
                    options={FILTER_BY_DEFECT_CATEGORY_OPTIONS.map(o => ({
                      text: o,
                      value: o
                    }))}
                    onChange={e =>
                      setFilter({
                        ...filter,
                        defectCategory: e.target.value
                      })
                    }
                    value={filter.defectCategory ? filter.defectCategory : ''}
                  />
                </FlexGrid.Col>
                <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                  <Select
                    label={FILTER_BY_STATUS.title}
                    placeholder={FILTER_BY_STATUS.placeholder}
                    options={STATUS_OPTIONS.map(o => ({
                      text: o,
                      value: o
                    }))}
                    onChange={e =>
                      setFilter({ ...filter, status: e.target.value })
                    }
                    value={filter.status ? filter.status : ''}
                  />
                </FlexGrid.Col>
                {role.name === 'ADMIN' ? (
                  <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                    <Select
                      label={FILTER_BY_ASSIGNEE.title}
                      placeholder={FILTER_BY_ASSIGNEE.placeholder}
                      options={assignedUsers.map(o => ({
                        text: `${o.firstName} ${o.lastName}`,
                        value: `${o.email}`
                      }))}
                      onChange={e =>
                        setFilter({ ...filter, assignee: e.target.value })
                      }
                      value={filter.assignee ? filter.assignee : ''}
                    />
                  </FlexGrid.Col>
                ) : (
                  ''
                )}
                <FlexGrid.Col xs={12}>
                  <Box pt={10}>
                    <Text>{filterByReportedDate} </Text>
                  </Box>
                </FlexGrid.Col>
                <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                  <InputWrapper>
                    <DateWrapper>
                      <DatePicker
                        dateFormat="yyyy/MM/dd"
                        placeholderText={FROM}
                        selected={
                          filter.startDate ? new Date(filter.startDate) : ''
                        }
                        onChange={value => {
                          const isEndDateBeforeStartDate =
                            filter.endDate &&
                            isBefore(new Date(filter.endDate), value);
                          setFilter({
                            ...filter,
                            startDate: format(value, 'yyyy-MM-dd'),
                            ...(isEndDateBeforeStartDate && { endDate: '' })
                          });
                        }}
                      />
                    </DateWrapper>
                  </InputWrapper>
                </FlexGrid.Col>
                <FlexGrid.Col xs={12} md={3} lg={3} sm={12}>
                  <InputWrapper>
                    <DateWrapper>
                      <DatePicker
                        dateFormat="yyyy/MM/dd"
                        placeholderText={TO}
                        minDate={
                          filter.startDate ? new Date(filter.startDate) : ''
                        }
                        selected={
                          filter.endDate ? new Date(filter.endDate) : ''
                        }
                        onChange={value => {
                          setFilter({
                            ...filter,
                            endDate: format(value, 'yyyy-MM-dd')
                          });
                        }}
                      />
                    </DateWrapper>
                  </InputWrapper>
                </FlexGrid.Col>
              </FlexGrid.Row>
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="row"
                pt={64}
                mdJustifyContent="flex-start"
                mdWidth={100}
                mdPadding="16px 0"
                margin="0 auto"
              >
                <Button
                  variant="secondary"
                  onClick={() =>
                    onApplyFilters({
                      ...filter
                      // ...(filter.startDate
                      //   ? {
                      //     startDate: filter.startDate
                      //       .toISOString()
                      //       .split('T')[0]
                      //   }
                      //   : {}),
                      // ...(filter.endDate
                      //   ? {
                      //     endDate: filter.endDate.toISOString().split('T')[0]
                      //   }
                      //   : {})
                    })
                  }
                >
                  {APPLY}
                </Button>
                <Box width="2"> </Box>
                <Button
                  onClick={() => {
                    setFilter({ ...FILTERS_INIT_STATE });
                    onResetFilters(true);
                  }}
                >
                  {RESET}
                </Button>
              </Box>
            </FlexGrid>
          </Box>
        </ExpandCollapse.Panel>
      </ExpandCollapse>
      {!!Object.values(defaultFilters).filter(value => !!value).length && (
        <Heading level="h3" tag="h4">
          {Showing_Result_For}
        </Heading>
      )}
      <Tags copy="fr">
        {Object.keys(defaultFilters).map(key => {
          if (defaultFilters[key]) {
            return (
              <Tags.Item onClick={() => onRemoveTagFilter(key)} isSelected>
                {filterKeyToShortTitleMap[key]}:{' '}
                {['startDate', 'endDate'].includes(key)
                  ? new Date(defaultFilters[key]).toDateString()
                  : defaultFilters[key]}
              </Tags.Item>
            );
          }
          return <></>;
        })}
      </Tags>
    </Box>
  );
};

Filters.propTypes = {
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  role: PropTypes.shape({ name: PropTypes.string }).isRequired,
  assignedUsers: PropTypes.shape().isRequired,
  defaultFilters: PropTypes.shape().isRequired
};
export default Filters;
